<template>
<div>
  <v-dialog v-model="openDialogUploadFile" persistent max-width="700px" >
    <v-card class="pa-3">
      <v-card-title>
        <span class="txt-head">อัปโหลดไฟล์</span>
      </v-card-title>
      <v-card-text>
        <v-row class="mt-0" justify=center>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>
        <v-container style="padding: 0px;">
          <v-row>
            <v-col cols="12">
              <span class="txt-head">ดาวน์โหลดแบบฟอร์ม<span class="ml-1"></span><span class="txt-font" style="color: grey; font-size: 14px;">&nbsp;(</span><span style="color: red;">*</span><span class="txt-font" style="color: grey; font-size: 14px;">กรุณาดาวน์โหลดแบบฟอร์มในการกรอกข้อมูล)</span></span>
            </v-col>
            <v-col cols="12" class="mt-n3">
              <v-btn
                id="btnbrowse"
                name="btnbrowse"
                outlined
                dark
                class="mr-0 pa-5 align-center icon-eye-color"
                @click="getFormPoa()"
              >
                <v-icon left dark class="icon-eye-color">fa-file-alt</v-icon>
                <span class="txt-font" style="font-weight: 500; font-size: 14px;color:#2BA197">เทมเพลตไฟล์ตำแหน่งงาน.xlsx</span>
                <v-icon right dark class="icon-eye-color">mdi-tray-arrow-down</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row class="mt-0" justify=start>
            <v-col cols="10">
              <span class="txt-head">เลือกบริษัท<span class="ml-1"></span><span class="txt-font" style="color: grey; font-size: 14px;">&nbsp;(</span><span style="color: red;">*</span><span class="txt-font" style="color: grey; font-size: 14px;">สามารถเลือกได้แค่ 1 รายการ)</span></span>
            </v-col>
            <v-col cols="8" class="form-control mt-n3">
              <v-autocomplete
                v-model="companyName"
                :items="selectData"
                item-text="companyFullNameTh"
                item-value="_id"
                outlined
                placeholder="ชื่อบริษัท"
                no-data-text="ไม่พบข้อมูล"
                class="mt-0"
                dense
                color="#333"
                clearable
                @click:clear="companyName=''"
                @keyup="initSelectData($event.target.value)"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" class="mt-n3">
              <span class="txt-head">อัปโหลดไฟล์<span class="ml-1"></span><span class="txt-font" style="color: grey; font-size: 14px;">&nbsp;(</span><span style="color: red;">*</span><span class="txt-font" style="color: grey; font-size: 14px;">สามารถเลือกได้แค่ 1 รายการ ไฟล์ .xlsx)</span></span>
            </v-col>
            <v-col cols="8" class="mt-n3">
              <div class="box-image3 mt-0">
                <v-row>
                  <v-col cols="7">
                    <span v-if="filesPosition.length === 0" class="text-right ml-5" style="color: #999999; font-size: 12px; margin-top: 0%;">อัปโหลดไฟล์</span>
                    <input type="file" id="files" accept=".xlsx" hidden ref="PickfilesPoa" multiple v-on:change="onFileSelected('poa')"/>
                    <div v-for="(file, key) in filesPosition" :name="file.name" class="file-listing ml-1 mt-0" :key="key">
                      <!-- <span class="mb-5" close :id="key" :name="file.name" @click:close="removeFile(key, 'poa')" color=""><strong class="txt-font">{{ file.name }}</strong>&nbsp;</span> -->
                      <v-chip close :id="key" :name="file.name" @click:close="removeFile(key, 'poa')" style="margin-top: -6%;"><strong class="txt-limit">{{ file.name }}</strong>&nbsp;</v-chip>
                    </div>
                  </v-col>
                  <v-col cols="2">
                    <v-btn
                      id="btnbrowse"
                      name="btnbrowse"
                      depressed
                      color="#F8F9FA"
                      class="ml-16 mb-0"
                      small
                      style="margin-top: -10px;;"
                      v-on:click="addFiles('poa')"
                      readOnly
                    >
                    <span class="txt-font" style="color: #2BA197; font-size:12px">เลือกไฟล์</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
              <v-progress-linear
                v-show="loadingFile === true"
                indeterminate
                color="cyan darken-0"
              ></v-progress-linear>
              <p class="txt-font" style="margin-top: 5%; font-size:14px">อัปโหลดได้เฉพาะไฟล์ .xlsx เท่านั้น</p>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="" color="#2BA197" outlined dark @click="closeDialog()">ปิด</v-btn>
        <v-btn v-if="this.companyName === '' || this.companyName === undefined || this.filesPosition.length === 0 || this.loadingFile === true" width="18%" class="ma-2 mr-2" color="grey" depressed disabled>ยืนยัน</v-btn>
        <v-btn v-else width="18%" class="ma-2 mr-2" color="#2BA197" dark @click="checkDataUpload()">ยืนยัน</v-btn>
        <!-- <v-btn v-else class="" color="#3776E9" dark @click="checkDataUpload()">ยืนยัน</v-btn> -->
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
    <OverlayLoading :loading="loading" />
  </v-dialog>
  <DialogCheckFile/>
</div>
</template>

<script>
import
{
  // getSelectCompanyEmployeeAll, //เก่า 29/03.66
  getSelectPositionNew,
  uploadFilePosition
} from '@/API/API'
import { EventBus } from '@/EventBus'
import FileSaver from 'file-saver'
import swal from 'sweetalert'
// import { OverlayLoading } from '@/components/index'
import OverlayLoading from '../../_template/OverlayLoading'
import DialogCheckFile from '../_dialog/dialogCheckFile.vue'
export default {
  components: {
    OverlayLoading,
    DialogCheckFile
  },
  data () {
    return {
      loading: false,
      loadingFile: false,
      openDialogUploadFile: false,
      selectData: [],
      filesPosition: [],
      companyName: '',
      nameUseInDocEng: '',
      alertText: {
        'worng template': 'เทมเพลตไฟล์ตำแหน่งงาน ไม่ถูกต้อง'
      }
    }
  },
  beforeDestroy () {
    EventBus.$off('opendialogUploadFile')
    EventBus.$off('closedialogCheckFile')
  },
  mounted () {
    EventBus.$on('opendialogUploadFile', this.openDialogUpload)
    EventBus.$on('closedialogCheckFile', this.closeDialogCheckFile)
    this.initSelectData()
    // EventBus.$on('opendialogmemberDepartment', this.openDialogMember)
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
  },
  computed: {
  },
  methods: {
    openDialogUpload (value) {
      // this.initDataTable()
      this.filesPosition = []
      this.openDialogUploadFile = true
    },
    closeDialogCheckFile () {
      this.removeFile(0, '')
    },
    async initSelectData (value) {
      const token = this.tokenUser
      const obj = {
        positionName: '',
        companyName: value,
        companyId: '',
        positionLevelName: '',
        positionLevel: ''
      }
      try {
        const res = await getSelectPositionNew(obj, token)
        if (res.success) {
          this.selectData = res.company
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getFormPoa () {
      await this.axios({
        method: 'get',
        responseType: 'blob',
        url: `${this.api}/api/vMonk/position/download/template`
        // url: `${this.api}/uploads/companyFile/fileposition.xlsx`
      }).then((response) => {
        FileSaver.saveAs(new Blob([response.data]), 'เทมเพลตไฟล์ตำแหน่งงาน.xlsx')
      }).catch(e => {
        console.log(e)
      })
    },
    addFiles (type) {
      if (type === 'certificate') {
        this.$refs.PickfilesCertificate.click()
      } else if (type === 'poa') {
        this.$refs.PickfilesPoa.click()
      }
    },
    onFileSelected (type) {
      var uploadedFilesPoa = this.$refs.PickfilesPoa.files
      for (let i = 0; i < uploadedFilesPoa.length; i++) {
        var dotindexPoa = uploadedFilesPoa[i].name.lastIndexOf('.')
        var FileExtensionPoa = uploadedFilesPoa[i].name.substr(dotindexPoa + 1).toLowerCase()
        if (FileExtensionPoa === 'xlsx') {
          this.filesPosition = []
          this.loadingFile = true
          this.filesPosition.push(uploadedFilesPoa[i])
          // this.loadingFile = false
          setTimeout(() => {
            this.loadingFile = false
          }, 2000)
        } else {
          swal('คำเตือน', `ไม่รองรับไฟล์${uploadedFilesPoa[i].name.substr(-4)}`, 'warning')
          this.loadingFile = false
        }
      }
    },
    removeFile (key, type) {
      this.filesPosition.splice(key, 1)
      const input = this.$refs.PickfilesPoa
      input.type = 'text'
      input.type = 'file'
      // console.log('remove key', key)
    },
    closeDialog () {
      this.companyName = ''
      this.removeFile(0, '')
      this.filesPosition = []
      this.openDialogUploadFile = false
    },
    async checkDataUpload () {
      this.loading = true
      var formData = new FormData()
      formData.append('companyId', this.companyName)
      formData.append('excelPosition', this.filesPosition[0])
      const obj = formData
      if (this.companyName === '' || this.filesPosition[0] === []) {
        swal('คำเตือน', this.companyName === '' ? 'กรุณาเลือกบริษัท' : this.filesPosition[0] === [] ? 'กรุณาอัปโหลดไฟล์' : 'กรุณากรอกข้อมูลให้ครบ', 'warning', {
          button: false,
          timer: 2000
        })
        this.loading = false
      } else {
        try {
          const res = await uploadFilePosition(obj, this.$store.state.token)
          if (res.success) {
            swal('สำเร็จ', 'อัปโหลดไฟล์ เรียบร้อย', 'success', {
              button: false,
              timer: 2000
            })
            this.openDialogUploadFile = false
            this.companyName = ''
            this.filesPosition = []
            this.loading = false
            this.closeDialog()
            EventBus.$emit('closedialogUploadFile')
            // this.$router.go(-1)
            // this.$router.push(router)
          } else {
            if (!res.data.duplicate) {
              // swal('ผิดพลาด', 'เทมเพลตไฟล์ตำแหน่งงาน ไม่ถูกต้อง', 'error')
              swal('ผิดพลาด', `${this.alertText[res.data.msg] || ''} กรุณาลองใหม่อีกครั้ง`, 'error')
            } else {
              EventBus.$emit('opendialogCheckFilePosition', res.data.duplicate)
              this.dialogConfirmSubmitData = false
            }
            this.loading = false
          }
        } catch (error) {
          console.log(error)
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
          this.dialogConfirmSubmitData = false
          this.loading = false
        } finally {
          // this.loadingEmployeeData = false
        }
      }
    },
    submitEdit (preName) {
      this.dialogCreate = false
    }
  }
}
</script>
<style scoped>
/* .txt-font {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
} */
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 5px;
  color: #757575;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.txt-leader-title {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: bold;
  font-size: 1.2rem;
}
.dialog-memeber-title {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: bold;
  font-size: 1.5rem;
}
.border-img {
  border-radius: 15px;
}
.btn_click {
  border: 2px solid gray;
  /* color: gray; */
  background-color: white;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
}
.box-image3 {
  border-width: 1px 1px;
  border-radius: 5px;
  border: 2px solid #e7e7e7;
  height: 40px;

}
.txt-limit {
  white-space: nowrap;
  width: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  /* border: 1px solid #000000; */
}
</style>
